<template>
  <div>
    <a-tooltip placement="top" :title="mailing.nombre">
      <a-tag :color="ESTADOS[mailing.estado].color" @click="visibleModalEmail = true" style="max-width: 100%; word-wrap: break-word;margin-bottom: 5px">
        {{ mailing.nombre.substring(0, 18)+'...' }}
      </a-tag>
    </a-tooltip>
  
    <a-modal v-model="visibleModalEmail" :title="mailing.nombre" width="70%" class="modelTagCalendar">
      <itemMail  :mailing="mailing" :opens="true" :keepOpen="true" :mailings="mailings" :listas="listas" />
      <template slot="footer">
        <a-button key="back" @click="visibleModalEmail = false" >Cerrar</a-button>
      </template>
    </a-modal>
  </div>   

</template>

<script>
import itemMail from './ItemMail.vue'
import utils from '../service/service'
export default {
  name: 'calendarTag',
  components: {
    itemMail,
  },
  props: {
    mailing: {},
    mailings: {},
    listas: {},
  },
  mixins:[utils],
  data() {
    return {
      visibleModalEmail: false,
    }
  },
  method:{
     
  }, 
  mounted: function() {
    
    
  },

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
